import React from 'react';
import {useActions} from "../../../hooks/useActions";
import {useTypedSelector} from '../../../hooks/useTypedSelector';
import {MusicService} from '../../../services/MusicService';
import Typewriter from 'typewriter-effect';


function TextStoryComponent({cpuStory, endGame}) {

    const {setCpuStory, startGame, setRoute} = useActions();
    const mapCpuIco = 'map-cpu-ico-' + cpuStory.story.name;
    const {isLoading} = useTypedSelector(state => state.auth);

    let text = '';
    if (cpuStory.action === 'before') {
        text = cpuStory.story[cpuStory.cpuNumber][cpuStory.action].step[0];
    } else {
        text = cpuStory.story[cpuStory.cpuNumber][cpuStory.action][endGame.winner].step[0];
    }

    return (<div>
        <div className={'map-cpu-ico ' + mapCpuIco.replace(/ /g, "-")}></div>
        <div className={'map-small-cpu-container'}>
            <div className="map-cpu-text">
                <Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                />
            </div>

            {(!isLoading) ?
                <div className={'map-battle-button'}>
                    {(cpuStory.action === 'before') ? (
                        <div className={'mapButtonOk'} onClick={async () => {
                            if (isLoading) {
                                return;
                            }

                            await startGame(cpuStory.cpuId);
                            await new Promise(r => setTimeout(r, 100));

                            setRoute('game');

                            MusicService.stopTutorial();
                            MusicService.stopMenu();
                            MusicService.playBattleMusic();
                        }}>
                        </div>
                    ) : (
                        <div className={'mapButtonOk'} onClick={() => {
                            if (isLoading) {
                                return;
                            }
                            cpuStory.action = null;
                            setCpuStory(cpuStory);

                            setRoute('boss');

                        }}>
                        </div>
                    )}
                </div>
                : <div></div>
            }

        </div>
    </div>);

}

export default TextStoryComponent;
